import map from "lodash/fp/map";
import isEmpty from "lodash/fp/isEmpty";
import fromPairs from "lodash/fp/fromPairs";

class Controller {
  constructor($mdDialog, Events) {
    "ngInject";

    this.Events = Events;
    this.$mdDialog = $mdDialog;
  }

  $onInit() {
    this.extraInfoItems = this.items ? [...this.items] : [];
    this.editEnabled = this.extraInfoItems.length < 1;
    this.getConfirmDialog = () =>
      this.$mdDialog
        .confirm()
        .title("Are you sure you want to remove this item ?")
        .ok("Ok")
        .cancel("Cancel");

    this.Events.on(
      this.successUpdateEvent,
      this.successUpdateExtraInfo.bind(this)
    );
  }

  toggleEdit() {
    this.editEnabled = !this.editEnabled;
  }

  dismissEdit() {
    this.extraInfoItems = [...this.items];
    this.toggleEdit();
  }

  addInfo() {
    const newItem = { key: "", value: "" };

    this.extraInfoItems.push(newItem);
  }

  removeInfo(idx, form) {
    const confirmDialog = this.getConfirmDialog();
    const removeItemConfirm = () =>
      this.$mdDialog.show(confirmDialog).then(
        () => {
          this.extraInfoItems.splice(idx, 1);
          if (!form.dirty) form.$setDirty();
        },
        () => {}
      );
    const checkEmptyItem = (item) => isEmpty(item.key) && isEmpty(item.value);
    const isEmptyItem = checkEmptyItem(this.extraInfoItems[idx]);

    return isEmptyItem
      ? this.extraInfoItems.splice(idx, 1)
      : removeItemConfirm();
  }

  saveChanges() {
    const infoFormatter = (info) =>
      fromPairs(map((item) => [item.key, item.value])(info));
    const info = infoFormatter(this.extraInfoItems);
    const methodName = this.resourceMethodName;
    const options = { info, methodName };

    this.Events.emit(this.updateEvent, options);
  }

  successUpdateExtraInfo() {
    this.toggleEdit();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/extraInformation/extraInformation.controller.js